module.exports = __webpack_public_path__ + "img/Website-designer-bro.d76b0778.svg";